module.exports = __webpack_public_path__ + "img/logo_yongqiao.1641520899224.png";